import { render, staticRenderFns } from "./WishlistProducts.vue?vue&type=template&id=a148e8fa&"
import script from "./WishlistProducts.vue?vue&type=script&lang=js&"
export * from "./WishlistProducts.vue?vue&type=script&lang=js&"
import style0 from "./WishlistProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports